import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import store from '../store'

import about_the_program_pt from '../i18n/pt-BR/about_the_program'
import campaigns_pt from '../i18n/pt-BR/campaigns'
import courses_pt from '../i18n/pt-BR/courses'
import country_pt from '../i18n/pt-BR/country'
import custom_pt from '../i18n/pt-BR/custom'
import common_pt from '../i18n/pt-BR/common'
import discussion_pt from '../i18n/pt-BR/discussion'
import events_pt from '../i18n/pt-BR/events'
import faq_pt from '../i18n/pt-BR/faq'
import feed_pt from '../i18n/pt-BR/feed'
import first_access_pt from '../i18n/pt-BR/first_access'
import footer_pt from '../i18n/pt-BR/footer'
import games_pt from '../i18n/pt-BR/games'
import header_pt from '../i18n/pt-BR/header'
import home_pt from '../i18n/pt-BR/home'
import insert_sales_pt from '../i18n/pt-BR/insert_sales'
import library_pt from '../i18n/pt-BR/library'
import live_classes_pt from '../i18n/pt-BR/live_classes'
import login_pt from '../i18n/pt-BR/login'
import podcasts_pt from '../i18n/pt-BR/podcasts'
import points_table_pt from '../i18n/pt-BR/points_table'
import presentials_pt from '../i18n/pt-BR/presentials'
import rewards_pt from '../i18n/pt-BR/rewards'
import sence_pt from '../i18n/pt-BR/sence'
import support_pt from '../i18n/pt-BR/support'
import survey_pt from '../i18n/pt-BR/survey'
import trails_pt from '../i18n/pt-BR/trails'
import upload_photos_pt from '../i18n/pt-BR/upload_photos'
import user_pt from '../i18n/pt-BR/user'
import webinar_pt from '../i18n/pt-BR/webinar'
import hotsite_pt from '../i18n/pt-BR/hotsite'

const messages_pt = Object.assign(
	about_the_program_pt,
	campaigns_pt,
	courses_pt,
	country_pt,
	common_pt,
	discussion_pt,
	events_pt,
	faq_pt,
	feed_pt,
	first_access_pt,
	footer_pt,
	games_pt,
	header_pt,
	home_pt,
	insert_sales_pt,
	library_pt,
	live_classes_pt,
	login_pt,
	podcasts_pt,
	points_table_pt,
	presentials_pt,
	rewards_pt,
	sence_pt,
	support_pt,
	survey_pt,
	trails_pt,
	upload_photos_pt,
	user_pt,
	webinar_pt,
	custom_pt,
	hotsite_pt
)

import about_the_program_en from '../i18n/en-US/about_the_program'
import campaigns_en from '../i18n/en-US/campaigns'
import courses_en from '../i18n/en-US/courses'
import country_en from '../i18n/en-US/country'
import custom_en from '../i18n/en-US/custom'
import common_en from '../i18n/en-US/common'
import discussion_en from '../i18n/en-US/discussion'
import events_en from '../i18n/en-US/events'
import faq_en from '../i18n/en-US/faq'
import feed_en from '../i18n/en-US/feed'
import first_access_en from '../i18n/en-US/first_access'
import footer_en from '../i18n/en-US/footer'
import games_en from '../i18n/en-US/games'
import header_en from '../i18n/en-US/header'
import home_en from '../i18n/en-US/home'
import insert_sales_en from '../i18n/en-US/insert_sales'
import library_en from '../i18n/en-US/library'
import live_classes_en from '../i18n/en-US/live_classes'
import login_en from '../i18n/en-US/login'
import podcasts_en from '../i18n/en-US/podcasts'
import points_table_en from '../i18n/en-US/points_table'
import presentials_en from '../i18n/en-US/presentials'
import rewards_en from '../i18n/en-US/rewards'
import sence_en from '../i18n/en-US/sence'
import support_en from '../i18n/en-US/support'
import survey_en from '../i18n/en-US/survey'
import trails_en from '../i18n/en-US/trails'
import upload_photos_en from '../i18n/en-US/upload_photos'
import user_en from '../i18n/en-US/user'
import webinar_en from '../i18n/en-US/webinar'
import hotsite_en from '../i18n/en-US/hotsite'

const messages_us = Object.assign(
	about_the_program_en,
	campaigns_en,
	courses_en,
	country_en,
	common_en,
	discussion_en,
	events_en,
	faq_en,
	feed_en,
	first_access_en,
	footer_en,
	games_en,
	header_en,
	home_en,
	insert_sales_en,
	library_en,
	live_classes_en,
	login_en,
	podcasts_en,
	points_table_en,
	presentials_en,
	rewards_en,
	sence_en,
	support_en,
	survey_en,
	trails_en,
	upload_photos_en,
	user_en,
	webinar_en,
	custom_en,
	hotsite_en
)

import about_the_program_es from '../i18n/es-ES/about_the_program'
import campaigns_es from '../i18n/es-ES/campaigns'
import courses_es from '../i18n/es-ES/courses'
import country_es from '../i18n/es-ES/country'
import custom_es from '../i18n/es-ES/custom'
import common_es from '../i18n/es-ES/common'
import discussion_es from '../i18n/es-ES/discussion'
import events_es from '../i18n/es-ES/events'
import faq_es from '../i18n/es-ES/faq'
import feed_es from '../i18n/es-ES/feed'
import first_access_es from '../i18n/es-ES/first_access'
import footer_es from '../i18n/es-ES/footer'
import games_es from '../i18n/es-ES/games'
import header_es from '../i18n/es-ES/header'
import home_es from '../i18n/es-ES/home'
import insert_sales_es from '../i18n/es-ES/insert_sales'
import library_es from '../i18n/es-ES/library'
import live_classes_es from '../i18n/es-ES/live_classes'
import login_es from '../i18n/es-ES/login'
import podcasts_es from '../i18n/es-ES/podcasts'
import points_table_es from '../i18n/es-ES/points_table'
import presentials_es from '../i18n/es-ES/presentials'
import rewards_es from '../i18n/es-ES/rewards'
import sence_es from '../i18n/es-ES/sence'
import support_es from '../i18n/es-ES/support'
import survey_es from '../i18n/es-ES/survey'
import trails_es from '../i18n/es-ES/trails'
import upload_photos_es from '../i18n/es-ES/upload_photos'
import user_es from '../i18n/es-ES/user'
import webinar_es from '../i18n/es-ES/webinar'
import hotsite_es from '../i18n/es-ES/hotsite'

const messages_es = Object.assign(
	about_the_program_es,
	campaigns_es,
	courses_es,
	country_es,
	common_es,
	discussion_es,
	events_es,
	faq_es,
	feed_es,
	first_access_es,
	footer_es,
	games_es,
	header_es,
	home_es,
	insert_sales_es,
	library_es,
	live_classes_es,
	login_es,
	podcasts_es,
	points_table_es,
	presentials_es,
	rewards_es,
	sence_es,
	support_es,
	survey_es,
	trails_es,
	upload_photos_es,
	user_es,
	webinar_es,
	custom_es,
	hotsite_es
)

import about_the_program_fr from '../i18n/fr-FR/about_the_program'
import campaigns_fr from '../i18n/fr-FR/campaigns'
import courses_fr from '../i18n/fr-FR/courses'
import country_fr from '../i18n/fr-FR/country'
import custom_fr from '../i18n/fr-FR/custom'
import common_fr from '../i18n/fr-FR/common'
import discussion_fr from '../i18n/fr-FR/discussion'
import events_fr from '../i18n/fr-FR/events'
import faq_fr from '../i18n/fr-FR/faq'
import feed_fr from '../i18n/fr-FR/feed'
import first_access_fr from '../i18n/fr-FR/first_access'
import footer_fr from '../i18n/fr-FR/footer'
import games_fr from '../i18n/fr-FR/games'
import header_fr from '../i18n/fr-FR/header'
import home_fr from '../i18n/fr-FR/home'
import insert_sales_fr from '../i18n/fr-FR/insert_sales'
import library_fr from '../i18n/fr-FR/library'
import live_classes_fr from '../i18n/fr-FR/live_classes'
import login_fr from '../i18n/fr-FR/login'
import podcasts_fr from '../i18n/fr-FR/podcasts'
import points_table_fr from '../i18n/fr-FR/points_table'
import presentials_fr from '../i18n/fr-FR/presentials'
import rewards_fr from '../i18n/fr-FR/rewards'
import sence_fr from '../i18n/fr-FR/sence'
import support_fr from '../i18n/fr-FR/support'
import survey_fr from '../i18n/fr-FR/survey'
import trails_fr from '../i18n/fr-FR/trails'
import upload_photos_fr from '../i18n/fr-FR/upload_photos'
import user_fr from '../i18n/fr-FR/user'
import webinar_fr from '../i18n/fr-FR/webinar'
import hotsite_fr from '../i18n/fr-FR/hotsite'

const messages_fr = Object.assign(
	about_the_program_fr,
	campaigns_fr,
	courses_fr,
	country_fr,
	common_fr,
	discussion_fr,
	events_fr,
	faq_fr,
	feed_fr,
	first_access_fr,
	footer_fr,
	games_fr,
	header_fr,
	home_fr,
	insert_sales_fr,
	library_fr,
	live_classes_fr,
	login_fr,
	podcasts_fr,
	points_table_fr,
	presentials_fr,
	rewards_fr,
	sence_fr,
	support_fr,
	survey_fr,
	trails_fr,
	upload_photos_fr,
	user_fr,
	webinar_fr,
	custom_fr,
	hotsite_fr
)

export default boot(({ app }) => {
	const userLocale = store.getters['common/user_language_selected'] ? store.getters['common/user_language_selected'] : 'pt-BR'
	const i18n = createI18n({
		locale: userLocale,
		fallbackWarn: false,
		missingWarn: false,
		silentFallbackWarn: true,
		silentTranslationWarn: true,
	})
	app.use(i18n)
	app.config.globalProperties.$i18n = i18n
	app.config.globalProperties.$t = i18n.t
	i18n.global.setLocaleMessage('pt-BR', messages_pt)
	i18n.global.setLocaleMessage('en-US', messages_us)
	i18n.global.setLocaleMessage('es-ES', messages_es)
	i18n.global.setLocaleMessage('fr-FR', messages_fr)
})
